export const defaultActions = [
    {
        name: 'Arbejde',
        example: 'F.eks. jeg vil booke tid i min kalender til mine opgaver',
    },
    {
        name: 'Familie',
        example: 'F.eks. jeg vil ringe til min bror hver søndag',
    },
    {
        name: 'Fritid',
        example:
            'F.eks. jeg skal gå fra arbejde senest kl 16, så jeg får mere fritid',
    },
    {
        name: 'Sport',
        example: 'F.eks. jeg vil gå en daglig tur, lige efter arbejde',
    },
    {
        name: 'Sundhed',
        example: 'F.eks. jeg vil spise noget grønt til alle måltider',
    },
    {
        name: 'Kærlighed',
        example:
            'F.eks. jeg vil invitere min kæreste på date én gang om måneden',
    },
    {
        name: 'Hobby',
        example: 'F.eks. jeg vil prøve en ny hobby af i løbet af efteråret',
    },
    {
        name: 'Økonomi',
        example: 'F.eks. jeg vil spare 500,- mere op om måneden',
    },
    {
        name: 'Socialt liv',
        example: 'F.eks. jeg vil ringe til min studieven i næste uge',
    },
];
